module.exports = __webpack_public_path__ + "img/section2_img4.de1d8f64.png";